import { Typography } from "@mui/material";
import LinkButton from "app/frontend/components/LinkButton";
import Panel from "app/frontend/components/Panel";
import BlueDivider from "app/frontend/components/static/BlueDivider";
import { EProjectTypes } from "app/frontend/constants/enums";
import { MICROMOBILITY_CONTRACTORS_HREF_PLACEHOLDER, QUICK_LINKS } from "app/frontend/constants/static_content";
import { useMicromobilityContractorsURL } from "app/frontend/hooks/contractors/useMicromobilityContractorsURL";
import { useCurrentProjectType } from "app/frontend/hooks/project/useCurrentProjectType";

interface IProps {
    link: {
        header: string;
        body: string;
        href: string;
        linkText: string;
        projects: EProjectTypes[];
    };
    panelSX?: React.CSSProperties;
}

const QuickLinks: React.FC<{ panelSX?: React.CSSProperties }> = ({ panelSX }) => {
    const projectType = useCurrentProjectType();

    return QUICK_LINKS.filter(
        (link) => link.projects.includes(EProjectTypes.ALL) || link.projects.includes(projectType),
    ).map((link) => <QuickLink key={link.header} link={link} panelSX={panelSX} />);
};

export const QuickLink: React.FC<IProps> = ({ link, panelSX }) => {
    const micromobilityContractorsUrl = useMicromobilityContractorsURL();

    return (
        <Panel
            sx={{
                ...panelSX,
                textAlign: "center",
            }}
        >
            <Typography variant="h3" component={"h2"}>
                {link.header}
            </Typography>
            <BlueDivider sx={{ margin: "0px auto", backgroundColor: "secondary.light", my: 2, borderWidth: 1 }} />
            <Typography variant="body2" component={"p"}>
                {link.body}
            </Typography>
            <br />
            <LinkButton
                button={{
                    variant: "contained",
                    size: "small",
                    sx: { textAlign: "center", borderRadius: 10, px: 3, py: 1, color: "white", boxShadow: "none" },
                }}
                href={
                    link.href === MICROMOBILITY_CONTRACTORS_HREF_PLACEHOLDER ? micromobilityContractorsUrl : link.href
                }
            >
                {link.linkText}
            </LinkButton>
        </Panel>
    );
};

export default QuickLinks;
